const SEPARATOR = '_';

// removes the initial `/` and replaces all other with `_`
export function getPageName(pathname: string) {
  return pathname.slice(1).replaceAll('/', SEPARATOR);
}
